import { render, staticRenderFns } from "./DesignInformDCF.vue?vue&type=template&id=0d15b3e8&scoped=true"
import script from "./DesignInformDCF.vue?vue&type=script&lang=js"
export * from "./DesignInformDCF.vue?vue&type=script&lang=js"
import style0 from "./DesignInformDCF.vue?vue&type=style&index=0&id=0d15b3e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d15b3e8",
  null
  
)

export default component.exports